export interface SseFrame {
    event: string;
    data: string;
    id: string | null;
}

export function getStreamErrorMessage(rawData: string | undefined, fallback: string): string {
    if (!rawData || !rawData.trim()) {
        return fallback;
    }

    try {
        const parsed = JSON.parse(rawData) as {
            error?: string;
            errorString?: string;
            detail?: string;
            message?: string;
        };

        return (
            parsed.error ||
            parsed.errorString ||
            (typeof parsed.detail === "string" ? parsed.detail : null) ||
            parsed.message ||
            fallback
        );
    } catch {
        return rawData.trim() || fallback;
    }
}

export function parseSseFrame(rawEvent: string): SseFrame {
    let event = "message";
    let id: string | null = null;
    const dataLines: string[] = [];

    rawEvent.split("\n").forEach((line) => {
        if (!line || line.startsWith(":")) {
            return;
        }

        const separatorIndex = line.indexOf(":");
        const field = separatorIndex === -1 ? line : line.slice(0, separatorIndex);
        const value =
            separatorIndex === -1 ? "" : line.slice(separatorIndex + 1).replace(/^ /, "");

        if (field === "event") {
            event = value;
        } else if (field === "data") {
            dataLines.push(value);
        } else if (field === "id") {
            id = value || null;
        }
    });

    return { event, data: dataLines.join("\n"), id };
}
